<template>
  <transition>
    <div
      v-if="filterToggle"
      class="pt-2"
    >
      <b-row>
        <!--Category Subject-->
        <b-col md="4">
          <b-form-group
            :label="$t(filterClass.getLabel(Direction.CATEGORY_SUBJECT))"
          >
            <v-select
              :id="Direction.CATEGORY_SUBJECT"
              v-model="filters[Direction.CATEGORY_SUBJECT]"
              :reduce="(option) => option.id"
              :options="categorySubjects"
              :get-option-label="(option) => $langName(option.name)"
              :placeholder="$t('All')"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group
            :label="$t(filterClass.getLabel(Direction.IS_PRIORITY))"
          >
            <v-select
              :id="Direction.IS_PRIORITY"
              v-model="filters[Direction.IS_PRIORITY]"
              :reduce="(option) => option.id"
              :options="yesNoOptions"
              :get-option-label="(option) => option.name"
              :placeholder="$t('All')"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <b-button
            class="mr-1"
            variant="success"
            @click="onFilter"
          >
            <feather-icon icon="LFilterIcon" />
            {{ $t('Filter') }}
          </b-button>
          <b-button
            variant="primary"
            @click="onGenerateExel"
          >
            <feather-icon
              icon="LFilterIcon"
            />
            {{ $t('Excel generate') }}
          </b-button>
        </b-col>
      </b-row>
    </div>
    <div v-else />
  </transition>
</template>

<script>
import vSelect from 'vue-select'
import {
  BButton, BRow, BCol,
  BFormGroup,
} from 'bootstrap-vue'
import { isObject } from '@core/utils/utils'
import Direction from '@/views/components/filters/service/Direction'

export default {
  name: 'DirectionFilterComponent',
  components: {
    BButton,
    BRow,
    BCol,
    vSelect,
    BFormGroup,
  },
  props: {
    filterToggle: {
      type: Boolean,
      required: true,
    },
    filters: {
      type: [Array, Object],
      default: () => ({}),
    },
    filterClass: {
      type: [Object, null],
      default: null,
    },
    selectedFilters: {
      type: [Array],
      default: () => ([]),
    },
  },
  data() {
    return {
      filterCustomer: {},
      yesNoOptions: [
        { id: true, name: this.$t('Yes') },
        { id: false, name: this.$t('No') },
      ],
    }
  },
  computed: {
    Direction() {
      return Direction
    },
    categorySubjects() {
      return this.$store.state['category-subject'].categorySubjects
    },
  },
  watch: {
    categorySubjects(newValue) {
      this.changeValue(newValue, Direction.CATEGORY_SUBJECT)
    },
  },
  created() {
    this.changeValue(this.yesNoOptions, Direction.IS_PRIORITY)
  },
  methods: {
    onGenerateExel() {
      this.$emit('onGenerateExel', this.filterClass.convertToQuery(this.filters), Direction.EXEL_GENERATE_ENDPOINT)
    },
    changeValue(newValue, field, id = 'id') {
      if (newValue.length && this.filters[field] !== null && this.filters[field] !== undefined && !isObject(this.filters[field])) {
        this.filters[field] = newValue.find(x => `${x[id]}` === `${this.filters[field]}`)
      }
    },
    onFilter() {
      this.$emit('onFilter', this.filterClass.convertToQuery(this.filters))
    },
    removeSelectedFilter(path) {
      this.filterClass.removeSelectedFilter(this.filters, path)
      this.$emit('onRemoveSelectedFilter', path)
    },
    removeSearchFilter() {
      this.$emit('searchQueryClear')
    },
  },
  setup() {
    return {
    }
  },
}
</script>

<style scoped>

</style>
